import { render, staticRenderFns } from "./LegalEntities.vue?vue&type=template&id=65e5d5bb&scoped=true"
import script from "./LegalEntities.vue?vue&type=script&lang=js"
export * from "./LegalEntities.vue?vue&type=script&lang=js"
import style0 from "./LegalEntities.vue?vue&type=style&index=0&id=65e5d5bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5d5bb",
  null
  
)

export default component.exports